<template>
  <div class="request-submitted" redesign>
    <!-- Header -->
    <div class="local-hero local-hero-dark no-padding">
      <div class="local-hero-graphic">
        <div class="local-hero-header-wrapper">
          <h1 class="local-hero-header" v-translate>
            You've successfully submitted your grant request.
          </h1>
        </div>
        <div class="local-hero-graphic-wrapper hidden-mobile">
          <div class="local-hero-graphic-holder park-bench">
            <ParkBenchSvg :color="organizationDetails.darkBrandColor" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-container request-submitted-form">
      <!-- Information -->
      <div class="form-header">
        <span v-translate>requestSubmittedCTA</span>
      </div>

      <div class="form-field card-shape review-message">
        <!-- Request CTA -->
        <div class="form-field-container">
          <p
            v-if="
              !organizationDetails.eventDocumentationEnabled &&
                !organizationDetails.expenseDocumentationEnabled
            "
            v-translate
          >
            We'll review your request and reply to you within two business days. If your request is
            approved, we'll notify you and send your grant funds to the account associated
            with your request. If we need additional information
            from you in order to process your grant request, we will let you know.
          </p>
          <p
            v-if="
              organizationDetails.eventDocumentationEnabled ||
                organizationDetails.expenseDocumentationEnabled
            "
            v-translate
          >
            We'll review your request and reply to you within two business days. If your request is
            approved, we'll notify you and send your grant funds to the account associated
            with your request. If we need additional information
            or documentation from you in order to process your grant request, we will let you know.
          </p>

          <!-- FAQ CTA -->
          <p>
            <translate>If you have more questions about how grant requests work, see the</translate
            ><span>&nbsp;</span> <router-link to="FAQ"><span v-translate>FAQ</span></router-link
            >.
          </p>
        </div>
      </div>
    </div>

    <NavigationBox
      v-if="organizationDetails.springFourEnabled"
      title="Additional help is just a click away!"
      description="Connect with local resources that provide financial assistance. Save on groceries, utilities, and prescriptions; access financial counseling; and more."
      @click="onClickFinancialResources"
      style="margin: 2rem 0;"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavigationBox from '@/components/NavigationBox'
import { analyticsMixin } from '@/services/googleAnalytics'
import ParkBenchSvg from '@/views/svg/ParkBenchSvg'

export default {
  name: 'RequestSubmitted',
  mixins: [analyticsMixin],
  components: {
    NavigationBox,
    ParkBenchSvg,
  },
  methods: {
    onSubmitRequest() {
      this.$router.push({ name: 'Home' })
    },
    onClickFinancialResources() {
      this.eventsTracker('clicked-cta-resources')
      this.$router.push({ name: 'FindResources' })
    },
  },
  computed: mapState(['organizationDetails']),
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/mixins/responsive';

.park-bench {
  align-items: end !important;
}

.request-submitted {
  display: flex;
  flex-direction: column;

  .request-submitted-form {
    @extend .constrain-tablet-and-up;
  }
}

.review-message {
  background-color: rgba(0, 42, 139, 0.1);
  box-shadow: none;
  -webkit-box-shadow: none;

  p:last-of-type {
    margin-bottom: 0;
  }
}
</style>
